<template>
  <div class="header-container" v-if="path">
    <div v-if="titleOnly" class="header header-back">
      <h2>{{ title }}</h2>
    </div>
    <div v-else-if="!backButton && routeTo !== '' && icon !== ''"
      class="header header-logo"
    >
      <div v-if="this.path === '/dashboard'" class="logo-container">
        <img
          :src="
            require(`@/assets/images/hospital-logo/neoparent-logo.png`)
          "
          alt="Hospital logo"
        />
      </div>
      <h2 v-if="title !== '' && title !== null">{{ title }}</h2>
      <div v-else class="logo-container">
        <img
          :src="
            require(`@/assets/images/hospital-logo/neoparent-logo.png`)
          "
          alt="Hospital logo"
        />
      </div>

      <Button
        :button-title="$t('button.profileSettings')"
        class="right mr-12"
        v-if="$store.getters.user.role === 'a' || $store.getters.user.role === 'n'"
        color="#31b9be"
        bgcolor="transparent"
        width="42px"
        padding="0"
        @click.native="redirect('/dashboard/profile')"
        icon="settings-pink"
      ></Button>
      <Button
        :buttontitle="routeToTitle"
        class="right"
        v-if="routeTo !== '' && icon !== ''"
        @click.native="redirect(routeTo)"
        width="42px"
        color="#31b9be"
        bgcolor="transparent"
        padding="0"
        :icon="icon"
      ></Button>
    </div>
    <div v-else-if="backButton" class="header header-back">
      <template v-if="(!this.$store.getters.user.role === 'n' || !this.$store.getters.user.hospital.multiAccountSupport) || path !== `/dashboard/nurse/${this.$store.getters.user.selectedNurseId}/patients`">
        <Button
          :button-title="$t('button.back')"
          v-if="backFunction"
          class="left"
          @click.native="backFunction"
          color="#31b9be"
          bgcolor="transparent"
          width="42px"
          padding="0"
          icon="back-pink"
        ></Button>
        <Button
          :button-title="$t('button.back')"
          v-if="backButton"
          class="left"
          @click.native="back"
          color="#31b9be"
          bgcolor="transparent"
          width="42px"
          padding="0"
          icon="back-pink"
        ></Button>
      </template>
      <template>
        <Button
          :button-title="$t('button.patients')"
          v-if="(this.$store.getters.user.role === 'n' || this.$store.getters.user.role === 'a') && this.$store.getters.user.selectedNurseId && path !== '/dashboard/nurses' && !path.includes('/dashboard/nurse/create')"
          class="left ml-12"
          @click.native="navigatePatients"
          color="#31b9be"
          bgcolor="transparent"
          width="42px"
          padding="0"
          icon="crib-pink"
        ></Button>
      </template>


        <Button
          :button-title="$t('button.home')"
          v-if="(this.$store.getters.user.role === 'n' || this.$store.getters.user.role === 'a')
        && (this.$store.getters.user.role === 'a' || (this.$store.getters.user.hospital == null
        || this.$store.getters.user.hospital.epdSettings == null
        || !this.$store.getters.user.hospital.epdSettings.epdEnabled))"
          class="left ml-24"
          @click.native="navigateHome"
          color="#31b9be"
          bgcolor="transparent"
          width="42px"
          padding="0"
          icon="home-pink"
        ></Button>
      <Button
        :button-title="$t('button.visits')"
        class="left ml-36"
        v-if="visitButton"
        @click.native="redirect(`/dashboard/nurse/${$store.getters.nurse.id}/visits?view=all`)"
        color="#31b9be"
        bgcolor="transparent"
        width="42px"
        padding="0"
        icon="clock-pink"
      ></Button>
      <Button
        :button-title="$t('button.home')"
        v-if="this.$store.getters.user.role === 'o' || this.$store.getters.user.role === 'p'"
        class="left ml-12"
        @click.native="navigateHomeParent"
        color="#31b9be"
        bgcolor="transparent"
        width="42px"
        padding="0"
        icon="home-pink"
      ></Button>
      <h2 v-if="title !== ''">{{ title }}
        <span  v-if="patientMode" class="ml-2 neoparent-pink-text clickable" @click="redirect('/dashboard/parent/add')" >
              <i v-if="hasActiveParents" class="fa fa-users"></i>
              <i v-if="!hasActiveParents" class="fa fa-users-slash"></i>
              <i v-if="!hasActiveParents" class="ml-1 fa fa-exclamation-triangle"></i>
        </span>
        <span  v-if="patientMode && visitState !== 'none'" class="ml-2 neoparent-pink-text clickable"
               @click="redirect(`/dashboard/nurse/${$store.getters.nurse.id}/visits?view=all`)">
              <span class="ml-1 mr-1">&mdash;</span>
              <i class="fa fa-clock"></i>
              <i v-if="visitState === 'new'" class="ml-1 fa fa-exclamation-triangle"></i>
        </span>
      </h2>
      <div v-else class="logo-container">
        <img
          :src="
            require(`@/assets/images/hospital-logo/neoparent-logo.png`)
          "
          alt="Hospital logo"
        />
      </div>
      <Button
        class="right"
        v-if="plusButton !== ''"
        @click.native="redirect(plusButton)"
        color="#31b9be"
        bgcolor="transparent"
        width="42px"
        padding="0"
        icon="plus-pink"
      ></Button>
      <Button
        class="right lang"
        v-if="addressLang"
        color="#31b9be"
        bgcolor="transparent"
        width="100px"
        padding="0"
      >
        <div v-if="$store.getters.user.patient">
          <country-flag
            size="normal"
            :rounded="true"
            v-for="lang in JSON.parse($store.getters.user.patient.languages)"
            :key="lang"
            :country="lang"
          />
        </div>
      </Button>
      <Button
        :button-title="$t('button.profileSettings')"
        class="right mr-12"
        v-if="$store.getters.user.role === 'a' || $store.getters.user.role === 'n' && path !== '/dashboard/profile'"
        color="#31b9be"
        bgcolor="transparent"
        width="42px"
        padding="0"
        @click.native="redirect('/dashboard/profile')"
        icon="settings-pink"
      ></Button>
      <Button
        class="right"
        v-if="displayLang"
        color="#31b9be"
        bgcolor="transparent"
        width="100px"
        padding="0"
        @click.native="redirect('/select/language')"
      >
        <country-flag size="normal" :rounded="true" :country="$i18n.locale" />
      </Button>
      <Button
        class="right"
        v-else-if="plusFunction"
        @click.native="plusFunction"
        color="#31b9be"
        bgcolor="transparent"
        width="42px"
        padding="0"
        icon="plus-pink"
      ></Button>
      <Button
        :button-title="routeToTitle"
        class="right"
        v-else-if="routeTo !== '' && icon !== ''"
        @click.native="redirect(routeTo)"
        width="42px"
        color="#31b9be"
        bgcolor="transparent"
        padding="0"
        :icon="icon"
      ></Button>

      <div v-if="viewSelect" class="view-select right">
        <a href="/visits" @click="this.fetchPatientsWithVisit()">
          Vandaag
        </a>
        <a href="/visits">
          Morgen
        </a>
        <a href="/visits">
          Alles
        </a>
      </div>
    </div>
    <div v-else>
      <a
        class="header-img"
        :href="this.$store.getters.user.role === 'n' ? '/patients' : '/menu'"
      >
        <template v-if="$store.getters.patient">
          <auto-rotate v-if="!$store.getters.patient.profilePicture || !$store.getters.patient.profilePicture.blobUri">
            <img
              class="patient-picture"
              src="@/assets/images/nophoto.png"
              :alt="`Profile picture of ${this.$store.getters.patient.firstName}`"
            />
          </auto-rotate>
          <auto-rotate v-else>
            <img
              class="patient-picture"
              :src="this.$store.getters.patient.profilePicture.blobUri"
              :alt="`Profile picture of ${this.$store.getters.patient.firstName}`"
            />
          </auto-rotate>
          <h2>{{ this.$store.getters.patient.firstName }}</h2>
        </template>
        <a href="/nurses" v-if="this.$store.getters.user.role === 'n'">
          <auto-rotate>
            <img
              v-if="!this.$store.getters.user.upload"
              class="nurse-picture"
              src="@/assets/images/nophoto.png"
              :alt="`Profile picture of ${this.$store.getters.user.firstName}`"
            />
            <img
              v-else
              class="nurse-picture"
              :src="
              `${this.$backendRoot}/uploads/${this.$store.getters.user.upload}?token=`
            "
              :alt="`Profile picture of ${this.$store.getters.user.firstName}`"
            />
          </auto-rotate>
          <p>{{ this.$store.getters.user.firstName }}</p>
        </a>
        <div v-else>
          <a
            href="/logout"
            class="notification"
          >
            <Button
              :buttontitle="$t('button.logout')"
              @click.native="redirect('/logout')"
              width="42px"
              color="#31b9be"
              bgcolor="transparent"
              padding="0"
              :icon="'sign-out-pink'"
            ></Button>
          </a>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import CountryFlag from "vue-country-flag";
import {curaeConsent, neoparentPatients as neoparentPatient, neoparentPatients} from "@/api";

export default {
  components: {
    CountryFlag
  },
  props: {
    backButton: Boolean,
    backFunction: Function,
    plusFunction: Function,
    titleOnly: Boolean,
    addressLang: Boolean,
    displayLang: Boolean,
    viewSelect: Boolean,
    visitButton: { default: null },
    plusButton: { default: "" },
    routeTo: { default: "" },
    routeToTitle: { default: "" },
    icon: { default: "" },
    title: { default: "" }
  },
  data: function() {
    return {
      path: null,
      parents: [],
      patientMode: false,
      visitState: 'none',
      unreadNotifications: this.$store.state.notifications.filter(notif => {
        return !notif.isRead;
      })
    };
  },
  async mounted() {
    this.path = window.location.pathname
    if (this.$store.getters.nurse != null) {
      if (this.$store.getters.nurse.patient?.id) {
        this.patientMode = true;
        await this.getParents();
        this.getVisitState();
      }
    }
  },
  computed: {
    hasActiveParents() {
      return this.parents != null && this.parents.find(x => x.active) != null;
    }
  },
  methods: {
    getVisitState() {
      const that = this;
      setTimeout(() => {
        const patientId = that.$store.getters.nurse.patient?.id;
        neoparentPatient.getPatientVisit(patientId).then(result => {
          const p = result.data.status;
          console.log('got patient', p)
          that.visitState = p;
        });
      }, 1000)
    },
    async getParents() {
      const that = this;
      const res = await neoparentPatients.getPatientParents(this.$store.getters.nurse.patient.id)
      if (res.data && res.data.parents.length) {
        const parents = res.data.parents
        for (let ndx in parents) {

          if (this.$store.getters.user.hospital.useCuraeConsent) {
            const consentRes = await curaeConsent.getUserConsent(parents[ndx].id)
            parents[ndx].active = consentRes.data.consentGiven
          } else {
            parents[ndx].active = true
          }
        }
        that.parents = parents;
      }
    },
    back() {
      window.history.back();
    },
    navigatePatients() {
      if (this.$store.getters.user.selectedNurseId) {
        window.location = `/dashboard/nurse/${this.$store.getters.user.selectedNurseId}/patients`
      } else {
        window.location = "/dashboard"
      }
    },

    navigateHome() {
      if (this.$store.getters.user.role === 'n') {
        if (this.$store.getters.user.hospital.multiAccountSupport) {
          window.location = `/dashboard/nurse/${this.$store.getters.user.selectedNurseId}/patients`
        } else {
          window.location = `/dashboard/nurses`
        }
      } else {
        window.location = "/dashboard"
      }
    },
    navigateHomeParent() {
      window.location = "/"
    }
  },
};
</script>

<style scoped lang="scss">
.header-container {
  overflow: auto;
  position: fixed;
  width: 100%;
  top: 0;
  background-color: #fff;
  z-index: 400;
}

button {
  position: absolute;

  &.lang div {
    display: flex;
    justify-content: flex-end;
  }
}

.left {
  left: 5px;
}

.right {
  right: 5px;
}

.header {
  position: relative;
  margin: 0rem 5%;
  font-weight: bold;
  border-bottom: 1px solid #e57378;
  height: 100%;

  display: flex;
  align-items: center;

  h2 {
    width: 100%;
    text-align: center;
  }
}

.header-back {
  .logo-container {
    margin-left: auto;
  }

  .view-select {
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    .router-link-active {
      color: #00a9b3;
    }

    a:not(.router-link-active) {
      font-weight: normal;
      text-decoration: underline;
    }
  }
}

.header-img {
  display: flex;
  align-items: center;
  margin: 0rem 5%;
  font-weight: bold;
  border-bottom: 1px solid #e57378;
}

.header-img .holder {
  margin: 0;

  .patient-picture {
    margin-right: 8px;
  }

  @media (min-width: 700px) {
    margin: 0 20px;
  }
}

.header-img .patient-picture {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  object-fit: cover;
  overflow: hidden;
}

.header-img .nurse-picture {
  width: 30px;
  height: 30px;
  border-radius: 50%;
}

.header-img :last-child {
  margin-left: auto;
  display: flex;
  align-items: center;
}

.header-img p {
  margin: 0;
}

.notification button {
  position: relative;
}

.logo-container {
  height: 50px;
  padding: 8px;

  & img {
    height: 100%;
    width: auto;
    object-fit: contain;
  }
}

.ml-24 {
  margin-left: 96px!important;
}

.ml-36 {
  margin-left: 144px!important;
}
.neoparent-pink-text {
  color: #E25D8A
}

@media (max-width: 768px) {
  .header {
    margin: 0 2%;
    min-height: 52px;
  }

  .header-back {
    min-height: 56px;

    h2 {
      margin: 0;
      /* Keep title clear of 3 left icons and up to 2 right icons on phone width. */
      padding: 0 92px 0 156px;
      font-size: 1rem;
      line-height: 1.15;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 100%;
    }
  }

  button.left,
  button.right {
    top: 50%;
    transform: translateY(-50%);
    width: 36px !important;
    min-width: 36px !important;
    height: 36px !important;
    background-size: 88% !important;
  }

  .left {
    left: 2px;
  }

  .right {
    right: 2px;
  }

  .ml-12 {
    margin-left: 38px !important;
  }

  .ml-24 {
    margin-left: 76px !important;
  }

  .ml-36 {
    margin-left: 114px !important;
  }

  .right.mr-12 {
    right: 42px;
    margin-right: 0 !important;
  }
}
</style>